module.exports = __webpack_public_path__ + "static/media/image03.b4e9a7aa.webp";